import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { SquaresFourIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import FiltersSection from '@/common/components/FiltersSection/FiltersSection'
import AppContext from '@/common/context/app.context'

import * as Styles from './styles'

const Header = ({ commonFilters, regions, onChangeCommonFilter, isUnifiedDashboard }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { info } = useContext(AppContext)

  return (
    <Styles.MainContainer>
      <Styles.TitleContainer>
        <SquaresFourIcon size={24} weight="light" color={theme.colors.outline.default} />
        <Text type="titleM" color={theme.colors.outline.default}>
          {isUnifiedDashboard
            ? t('Dashboard - Global')
            : t('Dashboard - {{storeName}}', { storeName: info?.selectedStore?.name })}
        </Text>
      </Styles.TitleContainer>
      <FiltersSection filters={commonFilters} onChange={onChangeCommonFilter} regions={regions} />
    </Styles.MainContainer>
  )
}

export default Header
